import { IMostReportedSnowfallItem } from 'api/home/types';
import { SnowWebcams } from 'components/home/SnowWebcams';
import MostReportedSnowfall from 'components/home/MostReportedSnowfall';
import React, { ComponentProps } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

type SnowWebcamsProps = ComponentProps<typeof SnowWebcams>;

type CamsAndSnowfallSectionProps = {
  snowWebcamsProps: SnowWebcamsProps;
  mostReportedSnowfallItems?: Array<IMostReportedSnowfallItem> | null;
  currentRegionSlug?: string;
};

const CamsAndSnowfallSection: React.FC<CamsAndSnowfallSectionProps> = ({
  snowWebcamsProps,
  mostReportedSnowfallItems,
  currentRegionSlug,
}) => {
  const hasMostReportedSnowfall = Boolean(
    mostReportedSnowfallItems?.some(({ snow }) => (snow?.last24 ?? 0) > 0),
  );
  const hasSnowWebcams = Boolean(snowWebcamsProps?.snowWebcams?.length);

  if (!hasSnowWebcams && !hasMostReportedSnowfall) {
    return null;
  }

  return (
    <section className={classNames(styles.section, 'mt-4')}>
      {hasSnowWebcams && (
        <div className={styles.snowWebcamsWrapper}>
          <SnowWebcams
            {...snowWebcamsProps}
            hasMostReportedSnowfall={hasMostReportedSnowfall}
            currentRegionSlug={currentRegionSlug}
          />
        </div>
      )}
      {hasMostReportedSnowfall && (
        <div className={styles.mostReportedSnowfallWrapper}>
          <MostReportedSnowfall items={mostReportedSnowfallItems} />
        </div>
      )}
    </section>
  );
};

export default CamsAndSnowfallSection;
